import React from "react";
import "./Header.css"
import { Link } from "react-router-dom";
const Header = () => {
  return <div>
    <div className="GNBcontainer">
    <h1><Link to="/"></Link></h1>
    <a href="#">
      <img src="images/bell.svg" alt="벨" />
      </a>
    </div>
  </div>;
};

export default Header;
